import { Theme, makeStyles, createStyles } from '@maas-components/core';
import shell, { StyleProps } from '../../../theme';

const styles = (theme: Theme) => {
    return createStyles({
        drawer: {
            top: '80px',
            width: 44,
            transitionProperty: 'width, height',
            transitionDuration: '0.5s, 0.5s',
            transitionTimingFunction: 'easeInQuint',
        },
        drawerOpen: {
            top: '80px',
            display: 'flex',
            justifyContent: 'space-between',

            // menu desktop - 260px size
            [theme.breakpoints.up(1324)]: {
                top: '80px',
                width: '260px',
                height: 'calc(100% - 80px)',
            },
            // menu mobile - 100% screen
            [theme.breakpoints.down(1324)]: {
                top: '80px',
                width: '100%',
                height: 'calc(100% - 80px)',
            },
            [theme.breakpoints.down('sm')]: {
                top: '68px',
                width: '100%',
                height: 'calc(100% - 68px)',
            },
            [theme.breakpoints.down('xs')]: {
                top: '60px',
                width: '100%',
                height: 'calc(100% - 60px)',
            },
        },
        drawerClose: {
            backgroundColor: (props: StyleProps) => `${shell[props.mode].sidebar.background}`,

            // menu desktop - vertical 100%
            [theme.breakpoints.up(1540)]: {
                top: '80px',
                cursor: 'pointer',
                height: '100%',
                overflowX: 'hidden',
                '&:hover': {
                    opacity: 0.9,
                },
            },

            [theme.breakpoints.between(1324, 1540)]: {
                top: '80px',
                cursor: 'pointer',
                height: '100%',
                overflowX: 'hidden',
                '&:hover': {
                    opacity: 0.9,
                },
            },

            // menu mobile - horizontal 100%
            [theme.breakpoints.down(1324)]: {
                top: '80px',
                width: '100%',
                cursor: 'pointer',
                height: '44px',
                display: 'flex',
                flex: 1,
                overflowY: 'hidden',
                color: (props: StyleProps) => `${shell[props.mode].sidebar.text}`,
            },

            [theme.breakpoints.down('sm')]: {
                top: '68px',
                width: '100%',
                cursor: 'pointer',
                height: '44px',
                display: 'flex',
                overflowY: 'hidden',
                color: (props: StyleProps) => `${shell[props.mode].sidebar.text}`,
            },

            [theme.breakpoints.down('xs')]: {
                top: '60px',
                width: '100%',
                cursor: 'pointer',
                height: '44px',
                display: 'flex',
                flex: 1,
                overflowY: 'hidden',
                color: (props: StyleProps) => `${shell[props.mode].sidebar.text}`,
            },
        },
        menuContainer: {
            display: 'flex',
            flexDirection: 'column',
            position: 'relative',
            backgroundColor: (props: StyleProps) => `${shell[props.mode].sidebar.background}`,
        },
        menuTitle: {
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
            padding: '10px 7px',
            color: (props: StyleProps) => `${shell[props.mode].sidebar.text}`,
            borderLeft: `4px solid ${theme.palette.primary.main}`,
            height: 43,
        },
        menuIcon: {
            marginRight: '9px',
            color: (props: StyleProps) => `${shell[props.mode].sidebar.icon}`,
            display: 'flex',
            alignItems: 'center',
        },
        menuName: {
            width: 182,
        },
        menuNameTruncate: {
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        },
        menuLink: {
            position: 'relative',
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
            paddingLeft: '14px',
            paddingBottom: '10px',
            color: (props: StyleProps) => `${shell[props.mode].sidebar.text}`,
            textDecoration: 'none',
            fontWeight: (props: StyleProps) => (props.mode === 'light' ? 400 : 500),
            borderLeft: `4px solid ${theme.palette.primary.main}`,
            '&:hover': {
                color: (props: StyleProps) => `${shell[props.mode].sidebar.textHover}`,
                textDecoration: 'none',
                cursor: 'pointer',
            },
            '&.active': {
                '& > span': {
                    backgroundColor: `${theme.palette.primary.main}`,
                },
                '& > p': {
                    fontWeight: '600',
                },
            },
        },
        menuLinkBall: {
            width: '8px',
            height: '8px',
            borderRadius: '25px',
            backgroundColor: `${theme.palette.grey[500]}`,
            marginRight: '14px',
        },
        menuLinkSymbol: {
            width: '1px',
            height: '17px',
            position: 'absolute',
            top: '22px',
            left: '17.5px',
            backgroundColor: `${theme.palette.grey[500]}`,
        },
        menuIconClose: {
            position: 'absolute',
            right: '10px',
            top: '10px',
            cursor: 'pointer',
            color: `${theme.palette.grey[500]}`,
        },
        menuLinkName: {
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            fontSize: '0.875rem',
            lineHeight: '1.5rem',
            letterSpacing: 0,
        },
        version: {
            color: (props: StyleProps) => `${shell[props.mode].sidebar.text}`,
            fontWeight: 500,
            padding: '20px',
        },
    });
};

export default makeStyles(styles, { name: 'MuiShellSidebarDrawer' });
